define("@latermedia/ember-later-analytics/components/ui/media-kit/fees-callout", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (or this.imageRates this.videoRates @email)}}
    <div class="cCI--booking" ...attributes>
      {{#if (or this.imageRates this.videoRates)}}
        <h2 class="o--page__title">{{t "media_kit.fees.min_rate" rate=this.lowestRate htmlSafe=true locale="en-us"}}</h2>
      {{/if}}
      {{#if @email}}
        <a href="mailto:{{@email}}" target="_blank" rel="noopener noreferrer" class="cCI--booking__btn qa--mediaKit_clientPage_contactMe_btn">Contact Me</a>
      {{/if}}
      {{!-- Booking Items --}}
      {{#if this.imageRates}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__title qa--mediaKit_clientPage_imageContent_title">{{t "media_kit.fees.image_content" locale="en-us"}}</div>
          <div class="cCI--bookingItem__value qa--mediaKit_clientPage_imageContent_rate">
            {{t "media_kit.fees.from" locale="en-us"}}{{this.imageRates.min_amount}}
            {{#if this.imageRates.max_amount}}
              {{t "media_kit.fees.to" locale="en-us"}}{{this.imageRates.max_amount}}
            {{/if}}
          </div>
        </div>
      {{/if}}
      {{#if this.videoRates}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__title qa--mediaKit_clientPage_videoContent_title">{{t "media_kit.fees.video_content" locale="en-us"}}</div>
          <div class="cCI--bookingItem__value qa--mediaKit_clientPage_videoContent_rate">
            {{t "media_kit.fees.from" locale="en-us"}}{{this.videoRates.min_amount}}
            {{#if this.videoRates.max_amount}}
              {{t "media_kit.fees.to" locale="en-us"}}{{this.videoRates.max_amount}}
            {{/if}}
          </div>
        </div>
      {{/if}}
      {{#if @otherTypesOfCollaboration}}
        {{!-- Divider --}}
        <hr class="u--m__tb">
        {{!-- Booking Item --}}
        <div class="cCI--bookingItem">
          <div class="cCI--bookingItem__description u--p__0 u--m__0 qa--mediaKit_clientPage_openToOtherCollab">{{t "media_kit.fees.other_collabs" locale="en-us"}}</div>
        </div>
      {{/if}}
    </div>
  {{/if}}
  
  */
  {
    "id": "2EhTMVcv",
    "block": "[[[41,[28,[37,1],[[30,0,[\"imageRates\"]],[30,0,[\"videoRates\"]],[30,1]],null],[[[1,\"  \"],[11,0],[24,0,\"cCI--booking\"],[17,2],[12],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"imageRates\"]],[30,0,[\"videoRates\"]]],null],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--page__title\"],[12],[1,[28,[35,2],[\"media_kit.fees.min_rate\"],[[\"rate\",\"htmlSafe\",\"locale\"],[[30,0,[\"lowestRate\"]],true,\"en-us\"]]]],[13],[1,\"\\n\"]],[]],null],[41,[30,1],[[[1,\"      \"],[10,3],[15,6,[29,[\"mailto:\",[30,1]]]],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[14,0,\"cCI--booking__btn qa--mediaKit_clientPage_contactMe_btn\"],[12],[1,\"Contact Me\"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"imageRates\"]],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__title qa--mediaKit_clientPage_imageContent_title\"],[12],[1,[28,[35,2],[\"media_kit.fees.image_content\"],[[\"locale\"],[\"en-us\"]]]],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__value qa--mediaKit_clientPage_imageContent_rate\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_kit.fees.from\"],[[\"locale\"],[\"en-us\"]]]],[1,[30,0,[\"imageRates\",\"min_amount\"]]],[1,\"\\n\"],[41,[30,0,[\"imageRates\",\"max_amount\"]],[[[1,\"            \"],[1,[28,[35,2],[\"media_kit.fees.to\"],[[\"locale\"],[\"en-us\"]]]],[1,[30,0,[\"imageRates\",\"max_amount\"]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"videoRates\"]],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__title qa--mediaKit_clientPage_videoContent_title\"],[12],[1,[28,[35,2],[\"media_kit.fees.video_content\"],[[\"locale\"],[\"en-us\"]]]],[13],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__value qa--mediaKit_clientPage_videoContent_rate\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_kit.fees.from\"],[[\"locale\"],[\"en-us\"]]]],[1,[30,0,[\"videoRates\",\"min_amount\"]]],[1,\"\\n\"],[41,[30,0,[\"videoRates\",\"max_amount\"]],[[[1,\"            \"],[1,[28,[35,2],[\"media_kit.fees.to\"],[[\"locale\"],[\"en-us\"]]]],[1,[30,0,[\"videoRates\",\"max_amount\"]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,3],[[[1,\"      \"],[10,\"hr\"],[14,0,\"u--m__tb\"],[12],[13],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cCI--bookingItem\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cCI--bookingItem__description u--p__0 u--m__0 qa--mediaKit_clientPage_openToOtherCollab\"],[12],[1,[28,[35,2],[\"media_kit.fees.other_collabs\"],[[\"locale\"],[\"en-us\"]]]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@email\",\"&attrs\",\"@otherTypesOfCollaboration\"],false,[\"if\",\"or\",\"t\"]]",
    "moduleName": "@latermedia/ember-later-analytics/components/ui/media-kit/fees-callout.hbs",
    "isStrictMode": false
  });
  class FeesCalloutComponent extends _component2.default {
    get lowestRate() {
      if (!this.args.rates) return 0;
      const sortedRates = [...this.args.rates].filter(rate => rate.max_amount).sort((a, b) => a?.min_amount - b?.min_amount);
      return sortedRates?.[0]?.min_amount || 0;
    }
    get imageRates() {
      const imageRates = this.args.rates?.filter(rate => rate.post_type === 'image');
      if (imageRates?.[0]?.max_amount) {
        return imageRates?.[0];
      }
      return;
    }
    get videoRates() {
      const videoRates = this.args.rates?.filter(rate => rate.post_type === 'video');
      if (videoRates?.[0]?.max_amount) {
        return videoRates?.[0];
      }
      return;
    }
  }
  _exports.default = FeesCalloutComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FeesCalloutComponent);
});